export const SWITCH_TO_PATTERN = 1;
export const PLAY_WORK = 2;
export const LOAD_WORK = 3;
export const UNLOAD_WORK = 4;
export const CHANGE_TRANSPOSE = 5;
export const CHANGE_VOLUME = 6;
export const CHANGE_BPM = 7;
export const CHANGE_COLOR = 8;
export const ROLL_ON = 9;
export const ROLL_OFF = 10;
